const tableColConstants = {
  date: '84px',
};

export default tableColConstants;
